import { getChatApiUrl } from './endpoints';

export const chatService = {
  async sendMessage(message, sessionId, language = 'tr', encodedBranch = null) {
    try {
      const url = getChatApiUrl('/api/chat');
      const payload = {
        message: message,
        session_id: sessionId,
        language: language,
      };

      // Add encoded branch if provided
      if (encodedBranch) {
        payload.encoded_branch = encodedBranch;
      }

      const response = await fetch(url, {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(payload),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          `Server error: ${response.status} - ${errorData.error || 'Unknown error'}`
        );
      }

      const data = await response.json();
      return data;
    } catch (error) {
      console.error('Chat API Error:', error);
      throw error;
    }
  },

  async clearHistory(sessionId) {
    try {
      const url = getChatApiUrl('/api/clear');
      const response = await fetch(url, {
        method: 'POST',

        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ session_id: sessionId }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.error || `HTTP error! status: ${response.status}`
        );
      }

      const data = await response.json();
      return data.message;
    } catch (error) {
      console.error('Clear history error:', error);
      throw error;
    }
  }
};
